import React from 'react';
import Story from './Story';
import useMediaQueries from '@stone/hooks/useMediaQueries';
import SwiperCore, { Navigation, A11y, Keyboard } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Icon from '@stone/ui/icon/Icon';
import { useTranslation } from 'react-i18next';
SwiperCore.use([Keyboard, Navigation, A11y]);
const StoryListing = (props) => {
    const { isMobile } = useMediaQueries();
    const { t } = useTranslation();
    const swiperProps = {
        watchOverflow: true,
        slidesPerView: 6 / 5,
        spaceBetween: 12,
        navigation: {
            prevEl: '.story-navigation--prev',
            nextEl: '.story-navigation--next',
        },
    };
    const renderNavigation = () => (React.createElement("div", { className: "navigation" },
        React.createElement("button", { className: "button story-navigation--prev", "aria-label": t('carousel.prevslidemessage') },
            React.createElement(Icon, { name: "left-chevron", family: "10" })),
        React.createElement("button", { className: "button story-navigation--next", "aria-label": t('carousel.nextslidemessage') },
            React.createElement(Icon, { name: "right-chevron", family: "10" }))));
    const renderCarousel = () => {
        var _a;
        return (React.createElement(Swiper, Object.assign({}, swiperProps), ((_a = props.stories) === null || _a === void 0 ? void 0 : _a.length) &&
            props.stories.map((story) => (React.createElement(SwiperSlide, { key: story.ID || story.id },
                React.createElement(Story, Object.assign({}, story)))))));
    };
    const renderGrid = () => (React.createElement("div", { className: "row story-listing__row" }, props === null || props === void 0 ? void 0 : props.stories.map((story) => (React.createElement("div", { className: "col-16 col-lg-8", key: story.ID || story.id },
        React.createElement(Story, Object.assign({}, story)))))));
    return (React.createElement("div", { className: "story-listing" },
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "story-listing__title" },
                React.createElement("h2", { className: "font__title" }, props.title),
                isMobile && renderNavigation()),
            isMobile ? renderCarousel() : renderGrid())));
};
export default StoryListing;
